export let switcher =
  <Switch extends { [key: string]: any }>(s: Switch) =>
  (key: keyof Switch) => {
    let v = s[key];
    if (typeof v == 'function') return v();
    return v;
  };
